(function () {
    'use strict';

    function toggleMenu() {
        const toggle = document.getElementById('isToggle');
        const navigation = document.getElementById('navigation');
        if (!toggle || !navigation) return;

        const opening = !navigation.classList.contains('open');
        toggle.classList.toggle('open', opening);
        navigation.classList.toggle('open', opening);
        toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
    }

    function updateScrollState() {
        const scrolled = document.documentElement.scrollTop >= 50 || document.body.scrollTop >= 50;
        const navbar = document.getElementById('topnav');
        const backToTop = document.getElementById('back-to-top');

        if (navbar) navbar.classList.toggle('nav-sticky', scrolled);
        if (backToTop) {
            const visible = document.documentElement.scrollTop > 500 || document.body.scrollTop > 500;
            backToTop.classList.toggle('flex', visible);
            backToTop.classList.toggle('hidden', !visible);
        }
    }

    function dismissDropdownMenus(except) {
        document.querySelectorAll('.dropdown').forEach(function (dropdown) {
            if (dropdown === except) return;
            const toggle = dropdown.querySelector('.dropdown-toggle');
            const menu = dropdown.querySelector('.dropdown-menu');
            if (toggle) toggle.classList.remove('is-open');
            if (menu) {
                menu.classList.remove('block');
                menu.classList.add('hidden');
            }
        });
    }

    function initDropdowns() {
        document.querySelectorAll('.dropdown').forEach(function (dropdown) {
            const toggle = dropdown.querySelector('.dropdown-toggle');
            const menu = dropdown.querySelector('.dropdown-menu');
            if (!toggle || !menu) return;

            toggle.addEventListener('click', function (event) {
                event.stopPropagation();
                const opening = !toggle.classList.contains('is-open');
                dismissDropdownMenus(opening ? dropdown : null);
                toggle.classList.toggle('is-open', opening);
                menu.classList.toggle('block', opening);
                menu.classList.toggle('hidden', !opening);
            });
        });
        window.addEventListener('click', function () { dismissDropdownMenus(); });
    }

    function initCounters() {
        const counters = document.querySelectorAll('.counter-value[data-target]');
        if (!counters.length) return;

        const observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                animateCounter(entry.target);
                observer.unobserve(entry.target);
            });
        }, { rootMargin: '100px' }) : null;

        counters.forEach(function (counter) {
            if (observer) observer.observe(counter);
            else animateCounter(counter);
        });
    }

    function animateCounter(counter) {
        const target = Number(counter.dataset.target || 0);
        if (!Number.isFinite(target)) return;
        const start = performance.now();
        const duration = 900;

        function frame(now) {
            const progress = Math.min((now - start) / duration, 1);
            counter.textContent = Math.round(target * progress);
            if (progress < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
    }

    window.toggleMenu = toggleMenu;
    window.topFunction = function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    document.addEventListener('DOMContentLoaded', function () {
        initDropdowns();
        initCounters();
        updateScrollState();
    });
    window.addEventListener('scroll', updateScrollState, { passive: true });
})();
